module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/chicken-mobile.c07ad117.png";